import type { IconProps } from '../types/IconProps.ts';
export const GlobeX: IconProps = {
    name: 'GlobeX',
    children: [
        `<path d="M11 2.05A10 10 0 1 0 22 12M2 12h20" />`,
        `<path d="M11 2.31C9.27 3.43 8 7.34 8 12c0 5.52 1.8 10 4 10s4-4.48 4-10M15 3l5 5M15 8l5-5" />`,
    ]
};